module.exports = __webpack_public_path__ + "img/HM.45cc90f9.png";